import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { baseurly } from '../../utils/apis.ts';
import { X_API_KEY } from '../../utils/apis.ts';
import { baseurl } from '../../utils/apis.ts';
import PdfDocumentLayout from '../../components/PdfDocumentLayout.tsx';

interface WorkInstruction {
  id: number;
  title: string;
  description: string;
  author: string;
  author_email: string;
  file: string | null;
  drawing: string | null;
}

const PDFWorkInstructionViewer: React.FC = () => {
  const { instructionId } = useParams();
  const [workInstruction, setWorkInstruction] = useState<WorkInstruction | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (instructionId) {
      fetch(`${baseurly}/work_instruction/${instructionId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-API-KEY': X_API_KEY,
        },
        credentials: "include",
      })
        .then((res) =>
          res.ok ? res.json() : Promise.reject('Failed to fetch work instruction')
        )
        .then((data) => {
          setWorkInstruction(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error('Error fetching work instruction:', err);
          setError('Unable to load work instruction');
          setLoading(false);
        });
    }
  }, [instructionId]);

  const fileUrl =
    workInstruction && workInstruction.file
      ? workInstruction.file.startsWith('http')
        ? workInstruction.file
        : `${baseurl}files/${workInstruction.file}`
      : '';

  if (loading) {
    return (
      <div className="min-h-screen bg-blue-900 p-6">
        <div className="text-white text-center mt-20">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-blue-900 p-6">
        <div className="text-white text-center mt-20">{error}</div>
      </div>
    );
  }

  return (
    <PdfDocumentLayout
      title={workInstruction?.title}
      fallbackTitle="Work Instruction"
      description={workInstruction?.description}
      authorName={workInstruction?.author}
      authorEmail={workInstruction?.author_email}
      fileUrl={fileUrl}
      hasDocument={Boolean(workInstruction && workInstruction.file)}
      emptyMessage="No PDF file available."
    />
  );
};

export default PDFWorkInstructionViewer;
